export const DELAYS_IN_SECONDS = [1, 0.2, 0.4];
